// extracted by mini-css-extract-plugin
module.exports = {"dialog":"dialog_dialog__kfEy5","active":"dialog_active__1bkr_","dialogContent":"dialog_dialogContent__TfeqP"};